import { Amplify } from "aws-amplify";

import { AwsRegionType } from "src/core/shared/api/globalSettings.api";

interface IProps {
  Auth: Pick<IAmplifyConfigAuth, "identityPoolId" | "region" | "userPoolId" | "userPoolWebClientId">;
  Storage: IAmplifyConfigStorage;
}

interface IAmplifyConfig {
  Analytics: IAmplifyConfigAnalytics;
  Auth: IAmplifyConfigAuth;
  Storage: IAmplifyConfigStorage;
}

interface IAmplifyConfigAnalytics {
  autoSessionRecord: false;
}

interface IAmplifyConfigAuth {
  authenticationFlowType: "USER_PASSWORD_AUTH";
  identityPoolId: string;
  mandatorySignIn: false;
  region: AwsRegionType;
  userPoolId: string;
  userPoolWebClientId: string;
  oauth: {
    domain: string;
    scope: string[];
    redirectSignIn: string;
    redirectSignOut: string;
    responseType: string;
  }
}

interface IAmplifyConfigStorage {
  AWSS3: {
    bucket: string;
    region: AwsRegionType;
  };
}

/**
 * Configures AWS Amplify client
 */
export const amplifyConfigure = ({ Auth, Storage }: IProps) => {
  const amplifyConfig: IAmplifyConfig = {
    Analytics: { autoSessionRecord: false },
    Auth: {
      // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
      authenticationFlowType: "USER_PASSWORD_AUTH",
      // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
      identityPoolId: Auth.identityPoolId,
      mandatorySignIn: false,
      // REQUIRED - Amazon Cognito Region
      region: Auth.region,
      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: Auth.userPoolId,
      userPoolWebClientId: Auth.userPoolWebClientId,
      oauth: {
        domain: process.env.REACT_APP_ENVIRONMENT === "production" ? "auth.mezze.io" : "staging-auth.mezze.io",
        scope: [
          "openid",
          "email",
          "profile"
        ],
        redirectSignIn: `${location.origin}/oauth`,
        redirectSignOut: `${location.origin}/logout`,
        responseType: "code"
      }
    },
    Storage: {
      AWSS3: {
        region: Storage.AWSS3.region,
        bucket: Storage.AWSS3.bucket
      }
    }
  };

  Amplify.configure(amplifyConfig);
};
